<template>
  <div>
    <div class="bannerBg" :style="{'background-image':'url(' + imgUrl + ')'}">
      <div class="box">
        <p class="title">{{title}}</p>
        <p class="text">{{text}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  computed: {},
  created() {
  },
  methods: {
  }
}
</script>

<style lang='less' scoped>
.bannerBg {
  //   background-image: url("../../assets/banner2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 424px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  .box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 1200px;
    height: 424px;

    .title {
      margin-top: 50px;
      font-size: 48px;
    }
    .text {
      margin-top: 24px;
      font-size: 18px;
    }
  }
}
</style>